import React, { useState, useEffect, useContext, useRef} from 'react';
import Menu from "./menu";
import styled from "styled-components";
import Footer from "./footer";
import Modal from 'react-modal';
import apiService from '../../services/apiService';
import CustomToast from '../Toast';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom'; // Add this import at the top

const Navbar = ({ children, isOrganisationDetails, showSidebar = true, showFooter = true, authToken }) => {
    const [show, setShow] = useState(false);
    const [selectedLanguage, setSelectedLanguage] = useState('');
    const [isModalOpen, setModalOpen] = useState(false);
    const [userData, setUserData] = useState(false);
    const [error, setError] = useState('');
    const [languages, setLanguages] = useState([]);
    const [showOrganisationDetails, setShowOrganisationDetails] = useState(false);
    const [isOrgUser, setIsOrgUser] = useState(false)
    const [setAuthToken] = useState(null);
    // const { selectedLanguages, updateLanguage } = useContext(LanguageContext);
    // const [userInfo, setUserInfo ] = useState()
    let orgInfo = JSON.parse(localStorage.getItem("orgInfo"));  

    const [isSidebarVisible, setSidebarVisible] = React.useState(window.innerWidth < 991 ? false : true);
    const [isSidebarBtnActive, setSidebarBtnActive] = React.useState(window.innerWidth < 991 ? true : false);
    const sidebarRef = useRef(null);

    const { t } = useTranslation();
    const [loader, setLoader] = useState(true);

    // Improved token parsing function
    const parseTokenFromUrl = () => {
        try {
            const urlParams = new URLSearchParams(window.location.search);
            const token = urlParams.get('ref');
            
            if (!token) {
                console.log("No token found in URL parameters");
                return null;
            }

            // First decode URI component (handles URL encoding like %20, %22, etc.)
            const decodedToken = decodeURIComponent(token);
            // Try to parse as JSON if it's a JSON string
            try {
                const parsedToken = JSON.parse(decodedToken);
                return parsedToken;
            } catch (jsonError) {
                // If JSON parsing fails, return the decoded string
                return decodedToken;
            }
        } catch (error) {
            console.error("Error parsing token from URL:", error);
            return null;
        }
    };

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const token = parseTokenFromUrl();
        const uid = urlParams.get('uid');
        const org_id = urlParams.get('org_id');
        const is_org_user = urlParams.get('is_org_user');

        // Log the parsed token for debugging
        if (token) {
            console.log("Parsed token:", token);
        }

        if (uid && is_org_user && org_id) {
            setIsOrgUser(true);
            setLoader(false);
        } else {
            setLoader(false);
        }
    }, []);

    const fetchData = async () => {
        try {
            let userDetails  = sessionStorage.getItem('user_details')
            let userTokenDetails = sessionStorage.getItem('tokenDetails');

            let baseDetails = sessionStorage.getItem('userDetail')
            if(baseDetails) {
                baseDetails = JSON.parse(baseDetails)
                if(baseDetails?.is_org_user) {
                    setIsOrgUser(true)
                }
            }
            if(userDetails) {
                userDetails = JSON.parse(userDetails)
                setUserData(userDetails);
            } else {
                const token = apiService.getAuthToken()
                const result = await apiService.get('get-org-user-info', token || authToken);
                sessionStorage.setItem('user_details', JSON.stringify(result.data))
                if(result && result.status == "success") {
                    setUserData(result.data);
                }
            }
        } catch (error) {
            setError('Error fetching user data');
            console.error(error);
            CustomToast.error('Error fetching user data');
            if (error == "Invalid token id!") {
                // Clear the token from local storage
                localStorage.removeItem('authToken');
                sessionStorage.removeItem('user_details');
                // Redirect to the original website
                // if (process.env.REACT_APP_ENV == "development") {
                //     window.location.href = 'https://staging.inclusional.com';
                // } else {
                //     window.location.href = 'https://site.inclusional.com';
                // }

                window.location.href = process.env.REACT_APP_LOGIN_URL
            }
        }
    };

    const getInitials = (name) => {
        return name?.split(' ').map(word => word.charAt(0)).join('').toUpperCase() || '';
    };

      useEffect(() => {
        // const userDetails = localStorage.getItem("userDetails")
        // if(userDetails){
           //  userDetails = JSON.parse(userDetails)
            // setUserInfo(userDetails);
            // userDetails['isOrg'] = true;
         //}

    // if (uid && is_org_user && org_id) {
    //   setIsOrgUser(true);
    //   setLoader(false);
    // } else {
    //   setLoader(false);
    // }

         const fetchOrgDetails = async () => {
            try {           
                    const token = apiService.getAuthToken()
                    let baseDetails = JSON.parse(sessionStorage.getItem('userDetail'));
                    let userTokenDetails = sessionStorage.getItem('tokenDetails');

                    await apiService.getv1(`get-org-details/${baseDetails?.org_id}`, token).then((result)=> {
                        localStorage.setItem('orgInfo', JSON.stringify(result?.data))
                    })
            } catch (error) {
             //   setLoader(false);
                console.error("Error fetching user details:", error);
            }
        };
    
        const checkSession = async () => {
            try {
               const token = apiService.getAuthToken() 
               const response = await apiService.get('check-user-session', token)
               console.log("check session", token);
                if (response && response?.status === 'failed' || response?.message == 'Invalid token id!') {
                    CustomToast.info('Your session has expired due to inactivity. Please log in again to continue.');
                    window.location.href = process.env.REACT_APP_LOGIN_URL;
                }
            } catch (error) {
              console.error('Error checking session:', error);
              if (error?.message == 'Invalid token id!') {
                // if(process.env.REACT_APP_ENV == "development") {
                //     window.location.href = `https://staging.inclusional.com`;
                //   } else {
                //     window.location.href = `https://site.inclusional.com`;
                // }
                CustomToast.info('Your session has expired due to inactivity. Please log in again to continue.');
                window.location.href = process.env.REACT_APP_LOGIN_URL;
              } 
            }
          };

         fetchOrgDetails();
         fetchData();
         checkSession();
     }, []);

    const openVideoModal = () => {
        setModalOpen(true);
    };

    const closeVideoModal = () => {
        setModalOpen(false);
    };

    const showSideBar = () => {
        setShow(!show);
    }

    const handleLogout = () => {
        // Clear the token from local storage
        localStorage.removeItem('authToken');
        sessionStorage.removeItem('user_details');
        sessionStorage.removeItem('userDetail')
        localStorage.removeItem('userLangArr')
        localStorage.removeItem('userLang')
        localStorage.removeItem('selectedLanguageInfo')
        localStorage.removeItem("CourseLanguagesData");
        // Redirect to the original website
        // if(process.env.REACT_APP_ENV == "development") {
        //     window.location.href = 'https://staging.inclusional.com';
        // } else {
        //     window.location.href = 'https://site.inclusional.com';
        // }
        window.location.href = process.env.REACT_APP_LOGIN_URL
    };

    const goToOrg = ()=> {
        let userDetails = sessionStorage.getItem("userDetail")
            if(userDetails) {
                userDetails = JSON.parse(userDetails)
                const encodedToken = encodeURIComponent(JSON.stringify(userDetails));
                if(process.env.REACT_APP_ENV == 'development') {
                    window.location.href = `${process.env.REACT_APP_ORG_URL}?ref=${encodedToken}`
                } else {
                    window.location.href = `${process.env.REACT_APP_ORG_URL}?ref=${encodedToken}`
                }
            } else {
                // if(process.env.REACT_APP_ENV == 'development') {
                //     window.location.href = "https://staging.inclusional.com"
                // } else {
                //     window.location.href = "https://site.inclusional.com"
                // }
                window.location.href = process.env.REACT_APP_LOGIN_URL
                //process.env.REACT_APP_LOGIN_URL
            }
    }



    const SidebarData = [
     {
      id: 'learning-space',
      title: 'Learning Space',
      path: '/',
      icon: '/images/learning_space_icon.png'
    },
    {
      id: 'organisation-details',
      title: 'Organisation Details',
      path: '/organisation-details',
      icon: '/images/org_details_icon.png'
    }
    ];
    const location = useLocation();

    const renderSidebarMenu = () => {
       
            return (
                <div className='sidebar-menu'>
            {SidebarData.map((item, index) => {
                const isActive = location.pathname === item.path;
                return (
                    <div 
                        key={index} 
                        className={`menu-item ${isActive ? 'active-menu-item' : ''}`}
                    >
                        <Menu item={item} onMenuClick={handleMenuItemClick} />
                    </div>
                );
            })}
        </div>
            );
    };

    useEffect(() => {
        const handleScroll = () => {
            const sidebarMenu = document.querySelector('.sidebar-menu');
            if (sidebarMenu) {
                if (window.scrollY > 50) {
                    sidebarMenu.classList.add('min-height');
                } else {
                    sidebarMenu.classList.remove('min-height');
                }
            }
        };
    
        window.addEventListener('scroll', handleScroll);
    
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const handleMenuItemClick = () => {
        // Hide sidebar when menu item is clicked, especially on mobile
        // if (window.innerWidth < 991) {
        //     setSidebarVisible(false);
        //     setSidebarBtnActive(true);
        // }
        checkMediaQuery();
    };

     const checkMediaQuery = () => {
        if (window.innerWidth < 991) {
            handleToggleSidebar();
        }
    };

    const handleToggleSidebar = () => {
        setSidebarVisible(!isSidebarVisible);
        setSidebarBtnActive(!isSidebarBtnActive);
    };

    // const getLang=async()=>{
    //     const token = apiService.getAuthToken()
    //     try {
    //     const languagesData = await apiService.getCms('getLangList',token)
    //     if (languagesData.status) {
    //       setLanguages(languagesData.data);
    //     } else {
    //       console.error("Error fetching languages:", languagesData.error);
    //     }
    //   } catch (error) {
    //     console.error("An unexpected error occurred:", error);
    //   }
    // }

    // useEffect(()=>{
    //     getLang()
    //     const lang=localStorage.getItem('selectedLanguage')
    //     if(lang){
    //         setSelectedLanguage(lang)
    //         updateLanguage(lang);
    //     }

    // },[])

    // const handleLangSelection = (value) => {
    //     setSelectedLanguage(value); 
    //     localStorage.setItem('selectedLanguage',(value))
    //     updateLanguage(value);
    // }

    return (
        <>
            <header className={`header ${show ? "add_body_padding" : ""}  `} id="admin-dash-header">
                <a href='/'> <img src="/images/logo.svg" alt="logo" className="navbar_logo" /></a>

                <div className='header_toggle'>
                    <i id="header-toggle"></i>
                </div>
                <div className="dropdown sidebar-profile d-flex align-items-center justify-content-end">
                    <div className="language-picker pe-lg-3 pe-0">
                    {isOrgUser ? 
                    <button  className='btn btn-secondary w-100 py-2 me-lg-4 me-0' onClick={()=> goToOrg()}>Go To Dashboard</button> : null
                    }
                        {/* <p>{selectedLanguage}</p> */}
                        {/* <form action="" className="language-picker__form">
                            <select
                                id="language-picker"
                                name="language-picker"
                                className='form-control custom-select'
                                value={selectedLanguage}
                                onChange={(e) => {handleLangSelection(e.target.value)}}>
                                    {languages && languages?.map((data) => {
                                            return <option value={data?._id}>{data?.name}</option>
                                        })}
                                <option lang="" value="english">ENG</option>
                            </select>
                        </form> */}
                    </div>
                    <div className='desktop-hide'>
                        <p className='mb-0 ms-3 fw-bold'>Hello, {userData.name}</p>
                        <div className='dropdown-toggle position-relative' id="dropdownUser3" data-bs-toggle="dropdown" aria-expanded="false">
                            <a className="d-flex align-items-center justify-content-center p-2 link-dark text-decoration-none " >
                                <svg
                                    fill="#000000"
                                    height="15px"
                                    width="15px"
                                    id="Layer_1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                    viewBox="0 0 330 330"
                                    xmlSpace="preserve"
                                >
                                    <path
                                        id="XMLID_225_"
                                        d="M325.607,79.393c-5.857-5.857-15.355-5.858-21.213,0.001l-139.39,139.393L25.607,79.393 c-5.857-5.857-15.355-5.858-21.213,0.001c-5.858,5.858-5.858,15.355,0,21.213l150.004,150c2.813,2.813,6.628,4.393,10.606,4.393 s7.794-1.581,10.606-4.394l149.996-150C331.465,94.749,331.465,85.251,325.607,79.393z"
                                    />
                                </svg>
                            </a>
                            <ul className="dropdown-menu text-small shadow" aria-labelledby="dropdownUser3">
                                <li>
                                    <button className="dropdown-item" onClick={() => window.location.href = '/my_profile'}>
                                        {t('header_page_my_profile')}
                                    </button>
                                </li>
                                <li>
                                    <button className="dropdown-item" onClick={handleLogout}>
                                        {t('header_page_logout')}
                                    </button>
                                </li>
                            </ul>

                        </div>
                    </div>
                    {orgInfo && orgInfo?.org_image ? <div className="admin-logo d-flex justify-content-center align-items-center" style={{ maxWidth: 350, maxHeight: 80 }}>
                    <img src={orgInfo?.org_image} className="img-fluid w-100" style={{ maxWidth: 150, maxHeight: 80, objectFit: "contain" }} /> </div> : null}
                    <div className='mobile-hide'>
                        <div className='dropdown-toggle position-relative' id="dropdownUser3" data-bs-toggle="dropdown" aria-expanded="false">
                            <a className="d-flex align-items-center justify-content-center p-2 link-dark text-decoration-none " >
                                {userData && userData?.pic && userData?.pic != "null" && userData?.pic != null ? (
                                    <img src={userData.pic} alt="avatar" className="avatar rounded-circle" />
                                ) : (
                                    <div className='initials font-28 text-white fw-bold text-uppercase'>{getInitials(userData.name)}</div>
                                )}
                            </a>
                            <ul className="dropdown-menu text-small shadow" aria-labelledby="dropdownUser3">
                                <li>
                                    <button className="dropdown-item" onClick={() => window.location.href = '/my_profile'}>
                                        {t('header_page_my_profile')}
                                    </button>
                                </li>
                                <li>
                                    <button className="dropdown-item" onClick={handleLogout}>
                                        {t('header_page_logout')}
                                    </button>
                                </li>
                            </ul>

                        </div>
                    </div>
                </div>
            </header>

            <div className='wrapper'>
              
                {showSidebar && (
                    <>
                        <button style={{ width: "max-content" }}
                            className={`sidebar-btn font-18 fw-bold primary_color text-white pt-0 my-4 mobile-hide ${isSidebarBtnActive ? 'active' : ''
                                }`}
                            onClick={handleToggleSidebar}
                        >
                            <span className="me-2"> </span>
                            {isSidebarBtnActive ? (
                                <>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 33 32" fill="none">
                                        <path d="M25.7778 17.3328L20.4444 22.6661L22.3111 24.5595L30.8711 15.9995L22.3111 7.43945L20.4444 9.33279L25.7778 14.6661H4.44443V17.3328H25.7778ZM4.44443 7.99945V10.6661H17.7778V7.99945H4.44443ZM4.44443 21.3328V23.9995H17.7778V21.3328H4.44443Z" fill="white" />
                                    </svg>{' '} 
                                </>
                            ) : (
                                <>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 33 33" fill="none">
                                        <path
                                            d="M6.99958 17.6668L12.3329 23.0001L10.4663 24.8934L1.90625 16.3334L10.4663 7.77344L12.3329 9.66677L6.99958 15.0001H28.3329V17.6668H6.99958ZM28.3329 8.33344V11.0001H14.9996V8.33344H28.3329ZM28.3329 21.6668V24.3334H14.9996V21.6668H28.3329Z"
                                            fill="white"
                                        /></svg>{' '} Hide Menu
                                </>
                            )}
                        </button>
                        <aside className={`sidebar h-100 ${show ? "review" : ""} `} id="admin-dash-nav" style={{ width: isSidebarVisible ? '270px' : '0', overflow: 'hidden', padding: '0px', transition: 'width 0.3s', background: "rgb(21, 107, 144)" }}>
                            <div className={`d-flex flex-column justify-content-between h-100 mt-4`}>
                                {renderSidebarMenu()}
                            </div>
                        </aside>
                    </>
                )}

                <main className={` ${show ? "add_body_padding" : "main"} `}>
                    {children}
                </main>
            </div>

            {/* {showFooter && <Footer />} */}
        </>
    );
}

export default Navbar;